import { render } from "./HospitalList.vue?vue&type=template&id=f6430c48&scoped=true"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"

import "./HospitalList.vue?vue&type=style&index=0&id=f6430c48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f6430c48"

export default script